import React, { Component } from 'react';
import _, { isEmpty, get } from 'lodash';
import routes from "../../../../../routes";
import { handleFieldError, initializeForm } from "../../../../../utils/form-validation";
import { formFields, radioBtn } from "./constant";
import { connect } from 'react-redux';
import Manual from "./Manual";
import PlatformLogin from "./PlatformLogin";
import RadioBtn from "../../../../../components/RadioBtn";
import { sortArray } from '../../../../../selectors';

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {},
            touched: {},
            errors: {},
            editMode: false,
            submited: false,
        };
    }

    componentWillMount() {
        // console.log(this.props)
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = this.props;
            history.push(routes.preSignIn);
        }
        const { form, errors } = initializeForm(formFields);

        form.addTypeFacebook = 0;

        this.setState({ form, errors });
    }

    // ====== on change function =======
    handleChange = (e, index) => {
        let { form } = this.state;
        let { value, name } = e.target;
        form[name] = value;
        this.setState({ form });

    }

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };

    render() {
        const { submited, errors, touched, form, advetiderListData } = this.state;
        return (
            <>
                <div className='main-class-wrap text-start'>
                    {/* <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
                    <RadioBtn
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.addTypeFacebook.key]}
                        setting={formFields[formFields.addTypeFacebook.key]}
                        error={errors[formFields.addTypeFacebook.key]}
                        submited={submited}
                        touched={touched[formFields.addTypeFacebook.key]}
                        options={sortArray((formFields[formFields.addTypeFacebook.key]).options)}
                    /> */}
                    {
                        (form.addTypeFacebook == 0) ?
                        <PlatformLogin
                        {...this.props}
                        />  :
                            form.addTypeFacebook == 1 ?
                                <Manual
                                {...this.props}
                                /> :
                                ""
                    }
                </div>
            </>
        );
    }
}

export default connect(
    state => ({})
)(index);